import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { useNavigate } from "react-router-dom/dist";
import CoreHttpHandler from "../../../http/services/CoreHttpHandler";
import moment from "moment";
import { Box, LinearProgress } from "@mui/material";


const Sec11 = () => {


	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);


	const getCourses = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"shareholder_education",
			"fetchCourses",
			{
				"status": true,
				"limit": 3,
				"page": 1

			},
			(res) => {
				setData(res.data.data.courses.courses)
				setIsLoading(false)
				// ToastAlertSuccess("Item removed Successfully");
			},
			(err) => {
				// ToastAlertError(
				// 	err?.response?.data?.message
				// 		? err?.response.data.message
				// 		: "something went wrong"
				// );
			}
		);
	};

	useEffect(() => {
		getCourses();
	}, [])

	const handleBtnClick = (data) => {
		navigate(`/myCourses/${data.module}`, {
			state: {
				...data,
			},
		});
	}


	return (
		<>
			<section className='sec sec11'>
				<div className='container'>
					<div className="flex_btw">

						<h1 className="bold">E-Learning</h1>
						<button className="rounded_btn" onClick={() => navigate("/ShareHolderEducation/learning")}>View More</button>
					</div>
					<div className="cards_wrap">
						<section className='courses' style={{ background: "transparent",padding:0 }}>
							<Container style={{ background: "transparent" }}>
								<Row  style={{border:"none"}}>
									{isLoading ?
									<Box sx={{ my: '5rem' }}>
										<LinearProgress color="success" />
									</Box>
									:
									data.map((e, i) => {
										return <>
											{/* <Col key={i} xl={4} lg={6} md={6}>

											<Card className="cards">
												<h4>{e.title}</h4>
												<p>{e.desc}</p>
												<div className="card-content">
													<h6>Class No.<br />{e.participants}</h6>
													<Button className="card_btn" variant="primary">Enrolled</Button>
												</div>
											</Card>
										</Col> */}
											<Col className="col col2" xs={12} sm={12} md={6} lg={4}>
												<Card className="cards">
													<div className="image-container">
														<img src={e.thumbnail} width="100%" style={{ maxHeight: "200px" }} alt={e.module} />
														<h5>{e.module}</h5>
														<div className="hover-text">
															<h5>{e.module}</h5>
															<p>{e.short_description}</p>
															<h6>Created Date: {moment(e?.dt).format("DD-MM-YYYY")}</h6>
															<h5>{e.mode_of_learning}</h5>
														</div>
													</div>
													{/* <p>{e.short_description}</p> */}
													<div className="card-content flex_btw">
														{/* <h6><span className="bold">Class No. </span><br />{e.date}</h6> */}
														{/* <h6><span className="bold">Class No. </span><br />{e.date}</h6> */}
														<h6></h6>
														<button className="rounded_btn" onClick={() => handleBtnClick(e)}>View Course</button>
													</div>
												</Card>
											</Col>
										</>
									})}
								</Row>
							</Container>
						</section>
					</div>


				</div>
			</section>



		</>
	);
};

export default Sec11;
